module.exports = __webpack_public_path__ + "static/media/ios-arrow-back.870690d2.svg";